<ion-card>
  <ion-card-header>
    <ion-card-title>Tantárgy-összevonás</ion-card-title>
    <ion-card-subtitle>Ugyanaz a tantárgy két néven — összefésülés mindenütt</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <ion-note color="medium" class="to-halvany" style="display:block;margin-bottom:10px">
      Ugyanaz a tantárgy több néven is bekerülhet a törzsadatba (<b>„dig.kult."</b> és
      <b>„digitális kultúra"</b>), jellemzően különböző importokból. Ilyenkor az órarend egy
      része az egyikre mutat, a másik a másikra, a tanmenet kettéválik, az értékelések pedig
      két tantárgy alatt gyűlnek.<br>
      Az összevonás <b>kilenc táblában</b> vezeti át a hivatkozást: órarend, kerettanterv (és
      rajta keresztül a tantárgyfelosztás), csoport–tantárgy kötés, tanmenet, értékelések,
      számonkérés-terv, tantárgysorrend, értékelési forma, mondatbank. A <b>naplózott órát</b>
      soha nem dobjuk el — ha ütközne, az marad meg. A művelet <b>nem vonható vissza</b>.
    </ion-note>

    <div class="to-sor">
      <ion-select label="Tanév" label-placement="stacked" interface="popover" fill="outline"
                  [(ngModel)]="ev" (ionChange)="betolt()">
        <ion-select-option [value]="null">— minden tanév —</ion-select-option>
        <ion-select-option *ngFor="let e of evek" [value]="e">{{ e }}/{{ e + 1 }}</ion-select-option>
      </ion-select>
      <span class="to-halvany" *ngIf="!toltodik">{{ tantargyak.length }} tantárgy</span>
    </div>

    <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <ng-container *ngIf="!toltodik">
      <!--  JAVASLATOK: hasonló nevek. Csak figyelemfelhívás – a döntés emberé.  -->
      <h3 *ngIf="javaslatok.length" style="font-size:1rem;margin:12px 0 6px">
        Gyanús párok ({{ javaslatok.length }})
      </h3>
      <div class="to-javaslat" *ngFor="let j of javaslatok">
        <b>{{ j.a.name }}</b>
        <span class="to-halvany">{{ j.a.orak }} óra · {{ j.a.ertekelesek }} értékelés</span>
        <ion-icon name="swap-horizontal-outline"></ion-icon>
        <b>{{ j.b.name }}</b>
        <span class="to-halvany">{{ j.b.orak }} óra · {{ j.b.ertekelesek }} értékelés</span>
        <span class="to-ok">({{ j.ok }})</span>
        <ion-button size="small" fill="outline" (click)="javaslatValaszt(j)">Megnézem</ion-button>
      </div>

      <div class="to-sor">
        <ion-select label="Beolvasztandó (megszűnik)" label-placement="stacked" interface="popover"
                    fill="outline" [(ngModel)]="forras" (ionChange)="elonez()">
          <ion-select-option *ngFor="let t of tantargyak" [value]="t.id">
            {{ t.name }} ({{ t.ev }}) — {{ t.orak }} óra
          </ion-select-option>
        </ion-select>
        <ion-select label="Megmaradó" label-placement="stacked" interface="popover"
                    fill="outline" [(ngModel)]="cel" (ionChange)="elonez()">
          <ion-select-option *ngFor="let t of tantargyak" [value]="t.id">
            {{ t.name }} ({{ t.ev }}) — {{ t.orak }} óra
          </ion-select-option>
        </ion-select>
      </div>

      <ng-container *ngIf="elonezet">
        <h3 style="font-size:1rem;margin:12px 0 6px">
          „{{ elonezet.forras.name }}" → „{{ elonezet.cel.name }}"
        </h3>
        <div class="to-osszegzo">
          <div class="to-kartya"><b>{{ elonezet.valtozas.orarend }}</b><span>óra kerül át</span></div>
          <div class="to-kartya"><b>{{ elonezet.valtozas.tanmenet_orak }}</b><span>tanmenet-sor</span></div>
          <div class="to-kartya"><b>{{ elonezet.valtozas.ertekelesek }}</b><span>értékelés</span></div>
          <div class="to-kartya"><b>{{ elonezet.valtozas.kerettanterv + elonezet.valtozas.kerettanterv_osszevont }}</b><span>kerettanterv-sor</span></div>
          <div class="to-kartya"><b>{{ elonezet.valtozas.ttf_atkotve }}</b><span>felosztás-sor átkötve</span></div>
          <div class="to-kartya" [class.gond]="elonezet.valtozas.orarend_utkozes_torolve">
            <b>{{ elonezet.valtozas.orarend_utkozes_torolve }}</b><span>ütköző óra törlődik</span>
          </div>
          <div class="to-kartya" [class.gond]="elonezet.valtozas.orarend_utkozes_naplozott">
            <b>{{ elonezet.valtozas.orarend_utkozes_naplozott }}</b><span>ütköző NAPLÓZOTT óra (marad)</span>
          </div>
        </div>

        <table class="to-tabla">
          <thead><tr><th>Amit átvezetünk</th><th class="szam">Darab</th></tr></thead>
          <tbody>
            <tr><td>Órarendi óra</td><td class="szam">{{ elonezet.valtozas.orarend }}</td></tr>
            <tr><td>Kerettanterv-sor (átkötve)</td><td class="szam">{{ elonezet.valtozas.kerettanterv }}</td></tr>
            <tr><td>Kerettanterv-sor (összevonva, a felosztás átkerül)</td><td class="szam">{{ elonezet.valtozas.kerettanterv_osszevont }}</td></tr>
            <tr><td>Csoport–tantárgy kötés</td><td class="szam">{{ elonezet.valtozas.csoport_kotes }}</td></tr>
            <tr><td>Csoport-kötés (fölösleges, törlődik)</td><td class="szam">{{ elonezet.valtozas.csoport_kotes_torolve }}</td></tr>
            <tr><td>Tanmenet-fejléc</td><td class="szam">{{ elonezet.valtozas.tanmenet }}</td></tr>
            <tr><td>Tanmenet-sor</td><td class="szam">{{ elonezet.valtozas.tanmenet_orak }}</td></tr>
            <tr><td>Tanmenet-sor (a célnak már van, eldobjuk)</td><td class="szam">{{ elonezet.valtozas.tanmenet_utkozes_torolve }}</td></tr>
            <tr><td>Tanulói értékelés</td><td class="szam">{{ elonezet.valtozas.ertekelesek }}</td></tr>
            <tr><td>Számonkérés-terv</td><td class="szam">{{ elonezet.valtozas.szamonkeres }}</td></tr>
            <tr><td>Tantárgysorrend / értékelési forma / mondatbank</td>
                <td class="szam">{{ elonezet.valtozas.sorrend + elonezet.valtozas.ertekeles_forma + elonezet.valtozas.mondatbank }}</td></tr>
          </tbody>
        </table>

        <div class="to-sor">
          <ion-button color="danger" [disabled]="fut" (click)="vegrehajt()">
            <ion-icon slot="start" name="git-merge-outline"></ion-icon>
            {{ fut ? 'Összevonás…' : 'Összevonás végrehajtása' }}
          </ion-button>
          <span class="to-halvany">A beolvasztott tantárgy törlődik. Nem vonható vissza.</span>
        </div>
      </ng-container>
    </ng-container>
  </ion-card-content>
</ion-card>

<!--  NÉVBETÖLTÉS a KRÉTA tantárgy-exportjából.
      A KRÉTA három néven ismeri a tantárgyat, a törzsadatban kettő fér el – ezért
      minden import új tantárgyat csinált a nála lévő néven. Ez a rész összevonja, ami
      már kettévált, ráírja a bizonyítvány-nevet, a többit pedig aliasként rögzíti,
      hogy a KÖVETKEZŐ import is a meglévő tantárgyra kössön. -->
<ion-card>
  <ion-card-header>
    <ion-card-title>Nevek betöltése a KRÉTA-exportból</ion-card-title>
    <ion-card-subtitle>
      A KRÉTA <b>három</b> néven ismeri a tantárgyat: a nevén, a rövidnevén és a
      bizonyítványban megjelenő néven. Nálunk kettő fér el, ezért minden import új
      tantárgyat csinált a nála lévő néven — innen a duplikáció.
    </ion-card-subtitle>
  </ion-card-header>
  <ion-card-content>
    <div class="to-sor">
      <input type="file" accept=".xlsx,.xls" (change)="nevFajlValasztva($event)" [disabled]="nevFut || !ev" />
      <span *ngIf="nevFajl" class="to-halvany">{{ nevFajl }} — <b>{{ nevSorok.length }}</b> sor</span>
      <ion-spinner name="crescent" *ngIf="nevFut"></ion-spinner>
    </div>
    <ion-note color="medium" style="font-size:.82rem; display:block; margin-top:4px">
      KRÉTA → <b>Nyilvántartás → Tantárgyak → Exportálás</b> („Tantárgyak minden adata").
      A <b>Tantárgy név</b>, <b>Tantárgy rövidnév</b> és <b>Bizonyítványban megjelenő név</b>
      oszlopokat használjuk; a többit figyelmen kívül hagyjuk.
      <span *ngIf="!ev"><br><b>Előbb válassz tanévet.</b></span>
    </ion-note>

    <div *ngIf="nevTerv" style="margin-top:12px">
      <div class="to-osszesites2">
        <b>{{ nevTerv.osszesites.osszevonas }}</b> összevonás ·
        <b>{{ nevTerv.osszesites.atnevezes }}</b> névfrissítés ·
        <b>{{ nevTerv.osszesites.alias }}</b> alias ·
        {{ nevTerv.osszesites.valtozatlan }} változatlan ·
        {{ nevTerv.osszesites.ismeretlen }} nincs meg nálunk
        <span *ngIf="nevTerv.osszesites.tobbertelmu"> ·
          <b class="to-piros">{{ nevTerv.osszesites.tobbertelmu }} többértelmű</b></span>
      </div>

      <div class="to-tabla-doboz" *ngIf="nevTervSzurt.length">
        <table class="to-tabla">
          <thead>
            <tr><th>Megmaradó név</th><th>Beolvad</th><th class="szam">Óra</th><th class="szam">Naplózott</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of nevTervSzurt" [class.to-gyanus]="t.allapot === 'tobbertelmu'">
              <td>{{ t.teljes }}<div class="to-halvany" *ngIf="t.rovid">rövid: {{ t.rovid }}</div></td>
              <td>
                <span *ngIf="t.forras">{{ t.forras.name }}</span>
                <span *ngIf="t.allapot === 'tobbertelmu'" class="to-piros">
                  kettőnél többre illeszkedik — kihagyjuk: {{ t.erintett?.join(', ') }}
                </span>
              </td>
              <td class="szam">{{ t.forras?.orak }}</td>
              <td class="szam">
                <b *ngIf="t.forras?.naplozott" class="to-piros">{{ t.forras.naplozott }}</b>
                <span *ngIf="!t.forras?.naplozott">{{ t.forras ? 0 : '' }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!--  Az összevonás KÜLÖN engedély: a névírás és az alias visszafordítható,
            a beolvasztás nem. -->
      <ion-item lines="none" *ngIf="nevTerv.osszesites.osszevonas">
        <ion-checkbox slot="start" [checked]="nevOsszevonas"
                      (ionChange)="nevOsszevonas = $event.detail.checked"></ion-checkbox>
        <ion-label class="ion-text-wrap">
          Az <b>összevonások</b> is fussanak le ({{ nevTerv.osszesites.osszevonas }} db)
          <br><small class="to-halvany">A beolvasztott tantárgy <b>törlődik</b>; az órái, a
          naplója és a jegyei átkerülnek a megmaradóra. Ez <b>nem vonható vissza</b>. Enélkül
          csak a nevek és az aliasok frissülnek — a duplikátumok maradnak.</small>
        </ion-label>
      </ion-item>

      <ion-button size="small" (click)="nevBetolt()" [disabled]="nevFut">
        <ion-icon slot="start" name="download-outline"></ion-icon>
        {{ nevFut ? 'Fut…' : 'Betöltés' }}
      </ion-button>
    </div>

    <div class="to-osszesites2" *ngIf="nevEredmeny" style="margin-top:10px">
      <b>Kész:</b> {{ nevEredmeny.atnevezve }} név frissítve ·
      {{ nevEredmeny.osszevonva }} összevonás ·
      {{ nevEredmeny.alias }} alias ·
      {{ nevEredmeny.kihagyva }} kihagyva
      <ul class="to-halvany" *ngIf="nevEredmeny.hibak?.length">
        <li *ngFor="let h of nevEredmeny.hibak" class="to-piros">{{ h }}</li>
      </ul>
    </div>
  </ion-card-content>
</ion-card>
